import React, { Component } from "react";
import styled from "styled-components";
import { withTranslation } from "react-i18next";
import GenericModal from "../../GenericModal";
import InfoIcon from "../../../images/info.svg";
import { connect } from "react-redux";
import { bindActionCreators } from 'redux'

import { actions as employeeActions } from '../../../actions/employee'
import { actions as maintenanceActions } from '../../../actions/maintenance'

import employeeService from '../../../services/Employee.service'
import { UserRoles } from '../../../constants'

import { history } from '../../../store'

const Content = styled.div`

  padding: 15px 20px 20px 20px;

  div.accept-award-documents {
    font-family: Lato-Regular;
    font-size: 12px;
    font-weight: normal;

    color: #666666;
    line-height: 16px;
    margin: 0;
    margin-top: 16px;
    padding-bottom: 2px;
  }
  > ul {
    margin: 0;
    padding: 0;
    list-style-type: none;
    height: auto;

    > li {
      padding-top: 7px;
      margin: 0;
    }

    > li:first-child {
      padding-top: 16.5px;
      border-top: 1px dotted #cccccc;
    }
  }
  > ul > li > a {
    display: block;
    font-family: Lato-Regular;
    font-size: 14px;
    color: #1d71bb;
    line-height: 16px;
    text-decoration: none;
    cursor: pointer;
  }

  > p {
    font-family: Lato-Regular;
    font-size: 14px;
    color: #2b2b2b;
    line-height: 22px;
  }
`;

const Footer = styled.div`
  > button.back-button {
    height: 41px;
    width: calc(50% - 10px);
    margin-right: 10px;

    @media (max-width: 768px) {
      height: 43px;
    }
  }

  > button.accept-award-button {
    height: 41px;
    width: calc(50% - 10px);
    margin-left: 10px;

    @media (max-width: 768px) {
      height: 43px;
    }
  }

  div > div {
    padding-bottom: 12px;
    > img {
      height: 20px;
      width: 20px;
      padding-right: 11px;
      float: left;
    }

    > p {
      font-family: Lato-Regular;
      font-size: 14px;
      color: #2b2b2b;
      line-height: 22px;

      > input {
        margin-right: 11px;
      }
    }

    > p.view-agreement {
      display: inline;
      font-family: Lato-Regular;
      font-size: 12px;
      color: #666666;
      text-align: left;
      line-height: 16px;
    }
  }
`;
export class AcceptAwardDialog extends Component {
  state = {
    acceptedTerms: false,
    viewAgreement: false
  };

  componentDidUpdate(prevProps) {
    if (this.props && prevProps.data.award.id !== this.props.data.award.id) {
      this.setState({
        acceptedTerms: false
      });
    }
  }
  acceptAwardHandler = event => {
    this.props.onAcceptAward(this.props.data.award);
  };

  viewAgrementHandler = event => {
    const target = event.target;
    const index = target.dataset.docindex;
    const documentId = this.props.data.award.documents[index].id


    if (target.className === "award-agreement-document") {
      this.setState({
        viewAgreement: true
      });
    }

    // download document
    this.props.actions.maintenance.checkMaintenaceStatus().then(isLive => {
      if (isLive) {
        this.props.actions.employee.getDocument(this.props.employee.id, this.props.data.award.id, documentId)
      } else {
        history.push("/maintenance", {})
      }
    })
  };

  handleInputChange = event => {

    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;

    this.setState({
      acceptedTerms: value
    });
  };

  render() {
    const { t } = this.props;
    const award = this.props.data.award;
    const viewOnly = employeeService.hasRole(this.props.employee.roles, UserRoles.ACCEPT_AWARD_VIEW) ? true : false

    const ConfirmViewAward = ({ viewAgreement }) => (
      <div>
        {viewAgreement && (
          <div>
            <p>
              <input
                tabIndex="0"
                type="checkbox"
                className="accept-terms-condition custom-checkbox"
                onChange={this.handleInputChange}
                checked={this.state && this.state.acceptedTerms}
                aria-label={t("AcceptAwardDialog.AcceptTerms")}
              />
              {t("AcceptAwardDialog.AcceptTerms")}
            </p>
          </div>
        )}

        {!viewAgreement && (
          <div>
            <img alt="" src={InfoIcon} />
            <p className="view-agreement">
              {t("AcceptAwardDialog.ViewAgreementText")}
            </p>
          </div>
        )}
      </div>
    );

    return (
      <GenericModal
        title={
          award &&
          t("AcceptAwardDialog.Title", {
            award_type: award.amazon_award_name
          })
        }
        visible={this.props.visible}
        data={this.props.data}
        onCloseDialog={this.props.onCloseDialog}
        width={380}
        className="accept-award-dialog"
      >
        <Content>
          <div className="accept-award-documents">
            {t("AcceptAwardDialog.TermsAndConditionsSection")}
          </div>
          <p>{t("AcceptAwardDialog.DialogTextContent")}</p>

          <div className="accept-award-documents">
            {t("AcceptAwardDialog.AwardDocumentsSection")}
          </div>
          <ul>
            {award.documents.map((el, index) => {
              return (
                <li key={`document_${index}`}>
                  <a
                    data-docindex={index}
                    tabIndex={0}
                    className={
                      el.award_agreement ? "award-agreement-document" : "non-award-agreement-document"
                    }
                    onClick={this.viewAgrementHandler}
                  >
                    {t('AcceptAwardDialog.DocumentTitle', { title: el.title })}
                  </a>
                </li>
              );
            })}
          </ul>
        </Content>
        <Footer>
          <ConfirmViewAward viewAgreement={this.state.viewAgreement} />
          <button className="secondary-button back-button" onClick={this.props.onBackButton}>
            {t("AcceptAwardDialog.BackButton")}
          </button>
          <button
            className="primary-button accept-award-button"
            onClick={this.acceptAwardHandler}
            disabled={(this.state && !this.state.acceptedTerms) || viewOnly}
          >
            {t("AcceptAwardDialog.AcceptButton")}
          </button>
        </Footer>
      </GenericModal>
    );
  }
}
const mapState = state => ({
  employee: state.employee
});

const mapDispatchToProps = dispatch => ({
  actions: {
    employee: bindActionCreators(employeeActions, dispatch),
    maintenance: bindActionCreators(maintenanceActions, dispatch),
  }
})

export default connect(mapState, mapDispatchToProps)(withTranslation("translations")(AcceptAwardDialog));
